import {action, makeAutoObservable} from "mobx";
import BillingPeriod from "../../../entities/BillingPeriod";
import CommonStore from "../../../stores/CommonStore";
import {BillingPeriodService} from "../../../service/BillingPeriodService";


class RemoveBillingPeriodStore {

    public billingPeriod: BillingPeriod;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, billingPeriod: BillingPeriod) {
        this.billingPeriod = billingPeriod;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }


    @action
    public async remove() {
        const response = await BillingPeriodService.remove(this.billingPeriod);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default RemoveBillingPeriodStore;